<template>
  <div class="mi">
    <div
      id="mi_map_container"
      :style="{ height: cheight + 'px', width: cwidth + 'px' }"
    >
      <iframe
        :src="url3d"
        frameborder="0"
        v-if="sdMap[type]"
        class="model3d"
        :style="{
          height: cwidth * 2 + 'px',
          width: cwidth + 'px',
          top: -(cwidth * 2 - cheight) / 2 + 'px',
        }"
      ></iframe>
      <el-amap
        v-else
        :zoom="zoom"
        :center="center"
        :amap-manager="amapManager"
        :events="events"
      ></el-amap>
    </div>

    <button id="mi_load_btn" @click="loadMap">加载</button>
  </div>
</template>

<script>
import { AMapManager } from "vue-amap";
let amapManager = new AMapManager();
export default {
  data() {
    return {
      urlPrefix: "",
      zoom: 13,
      center: [120.051238, 30.228232],
      amapManager,
      type: "",
      dgMap: {
        倒挂: "",
        // "2w+": "#ff869a",
        "2w+": {
          color: "#FFA52D",
          zIndex: 30,
        },
        "1-2w": {
          color: "#00DDFF",
          zIndex: 29,
        },
        "0.5-1w": {
          color: "#6A9DFF",
          zIndex: 28,
        },
        "0-0.5w": {
          color: "#AB82FF",
          zIndex: 27,
        },
        // 无: {
        //   color:"#FFD2A2",
        //   zIndex:26,
        // }
      },

      subwayStatus: {
        机场轨道快线: "dashed",
        杭富线: "dashed",
        "1号线": "solid",
        "2号线": "solid",
        "3号线": "solid",
        "4号线": "solid",
        "5号线": "solid",
        "6号线": "dashed",
        "7号线": "dashed",
        "8号线": "solid",
        "9号线": "dashed",
        "10号线": "dashed",
        "16号线": "solid",
        "1号线支线": "solid",
        "3号线支线": "dashed",
      },

      subwayColor: {
        机场轨道快线: "#c2272d",
        杭富线: "#67a2ca",
        "1号线": "#fe0000",
        "2号线": "#f15a25",
        "3号线": "#fbb03b",
        "4号线": "#8cc63e",
        "5号线": "#2aabe4",
        "6号线": "#0071bd",
        "7号线": "#ff0095",
        "8号线": "#ad70f9",
        "9号线": "#febe7e",
        "10号线": "#00f0f1",
        "16号线": "#bf526c",
        "1号线支线": "#fe0000",
        "3号线支线": "#fbb03b",

        "2号线延长": "#f15a25",
        "3号线延长": "#fbb03b",
        "4号线延长": "#8cc63e",
        "5号线延长": "#2aabe4",
        "6号线延长": "#0071bd",
        "9号线延长": "#febe7e",
        "10号线延长": "#00f0f1",
        "11号线": "#628a1a",
        "12号线": "#005f71",
        "14号线": "#666e9f",
        "15号线": "#a9a8a4",
        "13号线": "#e0c800",
        "18号线": "#c69c6c",
        "21号线": "#2267a0",
      },
      subwayName: {
        机场轨道快线: "机场",
        "1号线": "1",
        "2号线": "2",
        "3号线": "3",
        "4号线": "4",
        "5号线": "5",
        "6号线": "6",
        "7号线": "7",
        "8号线": "8",
        "9号线": "9",
        "10号线": "10",
        "16号线": "16",

        "1号线延长": "1",
        "2号线延长": "2",
        "3号线延长": "3",
        "4号线延长": "4",
        "5号线延长": "5",
        "6号线延长": "6",
        "9号线延长": "9",
        "10号线延长": "10",
        "11号线": "11",
        "12号线": "12",
        "14号线": "14",
        "15号线": "15",
        "13号线": "13",
        "18号线": "18",
        "21号线": "21",
      },
      url3d: "",
      cheight: 0,
      cwidth: 0,
      sdMap: {
        hxfb: "户型",
        sun: "日照",
        noise: "噪声",
        jg3d: "景观",
      },
      events: {
        complete: () => {
          console.log("地图加载完成");
          this.mapLoaded = true;
          if (this.mapDataLoaded) {
            this.addLoadedBtn();
          }
        },
      },
      mapLoaded: false,
      mapDataLoaded: false,
    };
  },
  created() {
    let params = this.$route.query;
    this.cheight = params.height;
    this.cwidth = params.width;

    window.addEventListener("message", (e) => {
      let data = e && e.data;
      if (data === "模型加载完成") {
        this.addLoadedBtn();
      }
    });
  },
  methods: {
    setMapDataLoad() {
      this.mapDataLoaded = true;
      if (this.mapLoaded) {
        this.addLoadedBtn();
      }
    },
    addLoadedBtn() {
      // puppeteer await page.waitForSelector('#mi_loaded'); 可实现等待加载后再截图
      let btn = document.getElementById("mi_loaded");
      if (!btn) {
        btn = document.createElement("button");
        btn.id = "mi_loaded";
        document.body.appendChild(btn);
      }
    },
    removeLoadedBtn() {
      let btn = document.getElementById("mi_loaded");
      if (btn) {
        btn.remove();
      }
    },
    loadMap() {
      this.removeLoadedBtn();
      this.mapDataLoaded = false;
      this.clearEmploymentMassMarks();
      let currentMap = amapManager.getMap();
      currentMap.clearMap();
      let params = this.$route.query;
      this.type = params.type;
      this.urlPrefix =
        params.city === "上海" ? this.$url_prefix2 : this.$url_prefix;
      if (params.city === "上海") {
        this.center = [121.487899, 31.249162];
      }

      let valueKeys = {
        daogua: 1.1,
        government: 3.1,
        market: 4,
        traffic: 5,
        school: 6,
        hospital: 7,
        scenery: 8,
        harmful: 9,
      };
      if (this.isAreaFacilityType(params.type)) {
        this.areaFacilityMap(params.estate_id, params.type);
        return;
      }
      if (this.isAreaEvaluationType(params.type)) {
        this.areaEvaluationMap(params.estate_id);
        return;
      }
      if (this.isAreaIndustryType(params.type)) {
        this.areaIndustryMap(params.estate_id, params.type);
        return;
      }
      if (this.isEstateFactorType(params.type)) {
        this.estateFactorMap(params.estate_id, params.type);
        return;
      }
      // 企业办公截图改用新价值评测代表点，避免继续绘制老评测分层。
      if (this.isEnterpriseOfficeValueType(params.type)) {
        this.enterpriseOfficeValueMap(params.estate_id, params.type);
        return;
      }
      if (valueKeys[params.type]) {
        this.valueMap(params.estate_id);
        return;
      }

      if (this.sdMap[params.type]) {
        this.loadHxfb(params.estate_id, params.type);
        return;
      }

      if (this.isLocationV2Type(params.type)) {
        // 新版配套截图：五个大类各自生成一张地图图。
        this.locationV2Map(params.estate_id, params.type);
        return;
      }

      switch (params.type) {
        case "landplan":
          this.cellsMap(params.estate_id);
          break;
        case "planning_news":
          this.planningNewsMap(params.estate_id);
          break;
        case "location":
          this.locationMap(params.estate_id);
          break;
        case "area":
          this.areaMap(params.estate_id);
          break;
        case "geo":
          this.geoMap(params.estate_id);
          break;
        case "store":
          this.storeMap(params.estate_id);
          break;
        case "industry":
          this.industryMap(params.estate_id);
          break;
        case "storeLocation":
          this.storeLocationMap(params.estate_id);
          break;
        case "locationDensity":
          this.locationDensityMap(params.estate_id);
          break;
        case "school_area":
          this.schoolAreaMap(params.estate_id);
          break;
        case "appoint":
          this.ykPathMap(params.estate_id);
          break;
        case "vr":
          this.vrMap(params.estate_id);
          break;
        case "estate_schools":
          this.estateSchoolsMap(params.estate_id);
          break;
        case "value_employment_income":
        case "hot_map":
          this.employmentIncomeMap(params.estate_id);
          break;
      }
    },
    addCallout(
      position,
      text0,
      color,
      zIndex,
      fontSize,
      text1,
      fcolor = "#fff",
      extraClassOrCircle = ""
    ) {
      zIndex = zIndex || 20;
      position = position || this.center;
      let text = text0 || "本楼盘";
      text1 = text1 || "";
      color = color || "FF612C";
      color = color.replace("#", "");
      let currentMap = amapManager.getMap();
      fontSize = fontSize || 26;
      if (text == "本楼盘") {
        fontSize = fontSize || 26;
        zIndex = 60;
        fcolor = "#fff";
      }
      const compactClass = fontSize <= 13 ? " mi-callout-sm" : "";
      const circleClass =
        extraClassOrCircle === true ? " mi-callout-circle" : "";
      const extraClass =
        typeof extraClassOrCircle === "string" && extraClassOrCircle
          ? ` ${extraClassOrCircle}`
          : "";
      let markerContent = `
              <div class="mi-callout${compactClass} mi-color-${color}${circleClass}${extraClass}" style="font-size:${fontSize}px; color:${fcolor};">
                <div class="text-center">${text}</div>
                <div class="text-center">${text1}</div>
              </div>
              `;
      let marker = new AMap.Marker({
        position: position,
        content: markerContent,
        offset: new AMap.Pixel(0, 0),
        anchor: "bottom-center",
        zIndex: zIndex,
      });
      marker.setMap(currentMap);
      return marker;
    },
    addEstateIcon(position) {
      const currentMap = amapManager.getMap();
      const markerContent = `
              <div class="mi-estate-icon-wrap">
                <img class="mi-estate-icon" src="/static/images/icon.png" />
              </div>
              `;
      const marker = new AMap.Marker({
        position: position || this.center,
        content: markerContent,
        offset: new AMap.Pixel(0, 0),
        anchor: "bottom-center",
        zIndex: 80,
      });
      marker.setMap(currentMap);
      return marker;
    },

    // 范围线
    addBackCircle(center, radius, nobg, storeType, deepOpacity) {
      let currentMap = amapManager.getMap();
      let circle = {};
      if (storeType) {
        circle = new AMap.Circle({
          center: center,
          radius: radius,
          strokeColor: "#FFFFFFFF",
          fillColor: "#FFFFFF66",
          strokeWidth: 1,
        });
      } else {
        circle = new AMap.Circle({
          center: center,
          radius: radius,
          fillColor: "#000000",
          fillOpacity: nobg ? 0 : deepOpacity ? deepOpacity : 0.05,
          strokeOpacity: 1,
          strokeWeight: 2,
          strokeColor: "#cccccc",
        });
      }

      currentMap.add(circle);

      let markerContent = `
              <div class="mi-callout mi-color-ffffff mi-distance-callout">
                ${(radius / 1000).toFixed(0)}公里
              </div>
              `;
      let latitude =
        Number(center[1]) +
        Number(((360 / 40000) * (radius / 1000)).toFixed(6));
      let marker = new AMap.Marker({
        position: [center[0], latitude],
        content: markerContent,
        offset: new AMap.Pixel(0, 0),
        anchor: "bottom-center",
        zIndex: 8,
      });
      marker.setMap(currentMap);
    },

    // 像素小圆点
    addDotCircle(center, radius, color) {
      let currentMap = amapManager.getMap();
      let circle = new AMap.Circle({
        center: center,
        radius: radius || 300,
        fillColor: color,
        strokeOpacity: 0,
      });
      currentMap.add(circle);
    },
    addDot16px(center, color) {
      let currentMap = amapManager.getMap();
      let marker = new AMap.Marker({
        position: center,
        content:
          '<div style="width:16px;height:16px;border-radius:50%;background:' +
          color +
          '"></div>',
        offset: new AMap.Pixel(-5.5, -5.5),
        zIndex: 10,
      });
      marker.setMap(currentMap);
      return marker;
    },
    estateSchoolsMap(id) {
      this.$axios
        .get(this.urlPrefix + "second/etate/school", {
          params: {
            estate_id: id,
          },
        })
        .then((res) => {
          let currentMap = amapManager.getMap();
          if (res.data && res.data.data && res.data.data.length) {
            let data = res.data.data || [];
            if (res.data.estate && res.data.estate.lnglat) {
              let lnglat = res.data.estate.lnglat.split("-")[0];
              let center = lnglat.split("|");
              this.center = center;
            }
            console.log("data", data);
            let plys = [];
            let colorArr = {
              小学: "#FDE247",
              初中: "#5CC65B",
            };
            let colorArr1 = {
              小学: "#FCA130",
              初中: "#5CC65B",
            };
            let colorArr2 = {
              小学: "#FDAB47",
              初中: "#5CC65B",
            };

            let lnglatArr = [];
            for (let index = 0; index < data.length; index++) {
              let element = data[index];
              let lnglat = element.lnglat.split("-")[0];
              lnglatArr.push(lnglat.split("|"));
              const item = element.dots;
              item.forEach((x) => {
                let polygon = new AMap.Polygon({
                  path: x.map((y) => y.split("|")),
                  strokeColor: colorArr1[element.school_type],
                  strokeWeight: 3,
                  strokeOpacity: 1,
                  strokeStyle: "dashed",
                  fillOpacity: 0.2,
                  fillColor: colorArr2[element.school_type],
                  lineJoin: "round",
                });
                currentMap.add(polygon);
                plys.push(polygon);
              });
            }
            // 先设置地图视野
            currentMap.setFitView(plys, false, [0, 0, 0, 0]);
            // 获取当前缩放级别
            const currentZoom = currentMap.getZoom();

            // 根据缩放级别动态计算偏移基准值
            // zoom越小，表示显示范围越大，需要更大的偏移量
            const getOffsetBase = (zoom) => {
              if (zoom < 15) return 0.004;
              if (zoom < 17) return 0.002;
              return 0.001;
            };
            const baseOffset = getOffsetBase(currentZoom);
            if (lnglatArr.length > 1) {
              // 检查所有标注点之间的距离
              for (let i = 1; i < lnglatArr.length; i++) {
                for (let j = 0; j < i; j++) {
                  const latDiff = Math.abs(
                    parseFloat(lnglatArr[i][1]) - parseFloat(lnglatArr[j][1])
                  );
                  if (latDiff < baseOffset) {
                    // 如果当前点比前一个点的纬度大，向上偏移
                    if (
                      parseFloat(lnglatArr[i][1]) > parseFloat(lnglatArr[j][1])
                    ) {
                      lnglatArr[i][1] =
                        parseFloat(lnglatArr[i][1]) + (baseOffset - latDiff);
                    } else {
                      // 否则向下偏移
                      lnglatArr[i][1] =
                        parseFloat(lnglatArr[i][1]) - (baseOffset - latDiff);
                    }
                  }
                }
              }
              // 添加标注
              for (let index = 0; index < lnglatArr.length; index++) {
                this.addCallout(
                  lnglatArr[index],
                  data[index].location_name,
                  colorArr[data[index].school_type],
                  60,
                  24,
                  "",
                  data[index].school_type == "小学" ? "#333" : "#333",
                  true
                );
              }
            } else {
              this.addCallout(
                lnglatArr[0],
                data[0].location_name,
                colorArr[data[0].school_type],
                60,
                24,
                "",
                data[0].school_type == "小学" ? "#333" : "#333",
                true
              );
            }
            // 确保所有内容都在视野内
            setTimeout(() => {
              currentMap.setFitView(plys, false, [0, 0, 0, 0]);
              this.setMapDataLoad();
            }, 100);
          }
        });
    },
    schoolAreaMap(id) {
      this.$axios
        .get(this.urlPrefix + "screenshot/data/school", {
          params: {
            id: id,
          },
        })
        .then((res) => {
          if (res.data.success) {
            let school = res.data.data;
            this.center = school.lnglat.split("-")[0].split("|");
            let timer = setTimeout(() => {
              clearTimeout(timer);
              let currentMap = amapManager.getMap();
              let areas = JSON.parse(school.dots);
              let plys = [];
              areas.forEach((x) => {
                let polygon = new AMap.Polygon({
                  path: x.map((y) => y.split("|")),
                  strokeColor: "#FF612C",
                  strokeWeight: 3, // 线条宽度，默认为 1
                  strokeOpacity: 1,
                  strokeStyle: "dashed",
                  fillOpacity: 0.2,
                  fillColor: "#FF612C",
                  lineJoin: "round", // 折线拐点连接处样式
                });
                currentMap.add(polygon);
                plys.push(polygon);
              });
              currentMap.setFitView(plys, false, [0, 0, 0, 0]);
              this.addCallout(
                this.center,
                school.location_name,
                null,
                60,
                26,
                "",
                "#fff"
              );
              // let timer = setTimeout(() => {
              //   let zoom = currentMap.getZoom();
              //   currentMap.setZoom(zoom + 0.5);
              //   clearTimeout(timer);
              // }, 100);

              this.setMapDataLoad();
            }, 200);
          }
        });
    },

    cellsMap(id) {
      let that = this;
      that.$axios
        .get(that.urlPrefix + "screenshot/data/cells", {
          params: {
            id: id,
          },
        })
        .then((res) => {
          if (res.data.success) {
            let data = res.data.data;
            that.zoom = 14;
            that.center = data.realEstate.lnglat.split("|");
            let timer = setTimeout(() => {
              clearTimeout(timer);
              let currentMap = amapManager.getMap();
              that.addBackCircle(that.center, 3000);
              data.cells.forEach((x) => {
                let polygon = new AMap.Polygon({
                  path: x.dots.split("-").map((y) => y.split("|")),
                  fillColor: x.type,
                  strokeColor: "#000000",
                  strokeWeight: 1,
                  strokeOpacity: 1,
                });
                currentMap.add(polygon);
              });

              that.addCallout();

              that.setMapDataLoad();
            }, 200);
          }
        });
    },

    valueMap(id) {
      let that = this;
      that.$axios
        .get(that.urlPrefix + "screenshot/data/values", {
          params: {
            estate_id: id,
          },
        })
        .then((res) => {
          if (res.data.success) {
            let data = res.data.data;
            let realEstate = res.data.realEstate;
            that.center = realEstate.lnglat.split("|");
            let timer = setTimeout(() => {
              clearTimeout(timer);
              that.addCallout();
              // that.addBackCircle(that.center, 3000);
              let type = that.type;
              let item = data.find((x) => x.type === type);
              let colorList = [
                "#FFA52D",
                "#6A9DFF",
                "#AB82FF",
                "#DC72FF",
                "#00DDFF",
                "#CE7704 ",
              ];
              let colorList1 = ["#9900FF", "#FF869A", "#FFAB89", "#FFAB89"]; //自己添加的，专门处理学校
              let colorList2 = ["#0700d9", "#0076de", "#6bd8e6"];
              let fillColor = "#73bdf3";
              let rowMap = {};
              let lineMap = {}; // 地铁线
              let rowSort = {
                company: {
                  上市企业: 1,
                  重要企业: 2,
                },
                office: {
                  "20万方+": 1,
                  "10万方+": 2,
                  "5万方+": 3,
                  "5万方以下": 4,
                },
                market: {
                  "20万方+": 1,
                  "10万方+": 2,
                  "5万方+": 3,
                  "5万方以下": 4,
                },
                traffic: {
                  地铁站: 2,
                  地铁线: 2.3,
                  高架: 3,
                },
                school: {
                  知名重点小学: 1,
                  重点小学: 2,
                  一般小学: 3,
                  知名重点初中: 4,
                  重点初中: 5,
                  一般初中: 6,
                },
                scenery: {
                  知名景观: 1,
                  重要景观: 2,
                  次要景观: 4,
                },
                hospital: {
                  三甲知名: 1,
                  三甲: 2,
                  其它: 4,
                },
                government: {
                  省级: 1,
                  市级: 2,
                  区级: 3,
                  其他: 4,
                },
                harmful: {
                  垃圾场: 1,
                  焚烧垃圾场: 1,
                  填埋垃圾场: 1,
                  垃圾中转站: 1,
                  高架铁路: 2,
                  高架: 2,
                  高速: 2,
                  高铁: 2,
                  铁路: 2,
                  快速路: 2,
                  墓地: 6,
                  变电站: 3,
                  化工厂: 5,
                  火葬场: 5,
                  其他: 5,
                },
              };
              let colorPriorityMap = {
                "#6bd8b6": 11, //绿
                "#73bdf3": 12, //蓝
                "#ffab89": 13, //橙
                "#ff869a": 14, //红
                "#9900ff": 15, //紫
                "#6bd8e6": 16,
                "#0076de": 17,
                "#0700d9": 18,
              };
              if (that.type === "daogua") {
                that.zoom = 14;
              }
              let zIndex = 20; //默认20
              item &&
                item.major.forEach((x) => {
                  let dot = x.lnglat.split("-")[0].split("|");
                  let rkey = "";
                  if (type === "daogua") {
                    rkey = that.formatPrice(x.price - realEstate.price);
                    if (rkey != "无") {
                      //无类型去掉了
                      fillColor = that.dgMap[rkey].color;
                      zIndex = that.dgMap[rkey].zIndex;
                    }
                  } else if (type === "company") {
                    if (x.school_type) {
                      rkey = x.school_type + "企业";
                    }
                  } else if (type === "office" || type === "market") {
                    rkey = that.formatKey(x.location_size);
                  } else if (type === "traffic") {
                    rkey = "高架";
                    if (x.school_type === "地铁") {
                      rkey = "地铁站";
                      let arr = x.lines.split("|");
                      arr.forEach((k) => (lineMap[k] = 1));
                      if (arr.length > 1) {
                        x.lines =
                          arr
                            .map((x) => parseInt(x))
                            .filter((x) => x)
                            .join("、") + "号线";
                        if (arr.includes("机场轨道快线")) {
                          x.lines = x.lines + "，机场线";
                        }
                      } else {
                        x.lines = arr[0] || "";
                        if (x.lines === "机场轨道快线") {
                          x.lines = "机场线";
                        }
                      }
                    }
                  } else if (type === "school") {
                    let str1 = "初中";
                    let str2 = "一般";
                    if (x.school_type.includes("小学")) {
                      str1 = "小学";
                    }
                    // radius = radiusList[2];
                    x.location_size = "";
                    if (["国家级重点", "省重点"].includes(x.location_size)) {
                      str2 = "知名重点";
                      // radius = radiusList[0];
                      x.location_size = "知名";
                    } else if (x.location_size === "市重点") {
                      str2 = "重点";
                      x.location_size = "重点";
                      // radius = radiusList[1];
                    }
                    rkey = str2 + str1;
                  } else if (type === "hospital") {
                    rkey = "其它";
                    if (x.location_size === "三甲特") {
                      rkey = "三甲知名";
                      x.location_size = "三甲知名";
                    } else if (x.location_size === "三甲") {
                      rkey = "三甲";
                    }
                  } else if (type === "scenery") {
                    rkey = "次要景观";
                    if (x.location_size == "5A" || x.location_size == "知名") {
                      rkey = "知名景观";
                    } else if (["4A", "3A"].includes(x.location_size)) {
                      rkey = "重要景观";
                    }
                  } else if (type === "harmful") {
                    rkey = x.school_type;
                  } else if (type === "government") {
                    rkey = "其他";
                    if (["省级", "市级", "区级"].includes(x.location_size))
                      rkey = x.location_size;
                  }

                  let isTopLevel = false;
                  let colorIndex = 0;
                  if (rkey) {
                    rowMap[rkey] = (rowMap[rkey] || 0) + 1;
                    if (rowSort[type]) {
                      let index = rowSort[type][rkey] - 1;
                      colorIndex = index;
                      if (type === "school") {
                        if (index > 2) {
                          index = index % 3;
                          fillColor = colorList2[index];
                        } else {
                          fillColor = colorList1[index];
                        }
                      } else if (
                        (type === "market" || type === "office") &&
                        x.location_size < 5
                      ) {
                        fillColor = "#FFD2A2";
                      } else if (type === "government" && !x.location_size) {
                        fillColor = "#FFD2A2";
                      } else {
                        fillColor = colorList[index];
                        zIndex = 30 - index;
                      }
                      isTopLevel = index == 0;
                    }
                  }

                  if (
                    (type == "office" || type == "market") &&
                    colorIndex > 1
                  ) {
                    that.addDotCircle(dot, 100, fillColor);
                  } else if (type === "government" && fillColor == "#FFD2A2") {
                    that.addDotCircle(dot, 100, fillColor);
                  } else if (
                    (type === "hospital" && rkey === "其它") ||
                    (type === "scenery" && rkey === "次要景观")
                  ) {
                    that.addDotCircle(dot, 100, "#FFF9DB");
                  } else {
                    let text = x.location_name;
                    let text1 = "";
                    if (type === "daogua") {
                      text = x.real_estate_name;
                      // text1 = "¥" + x.price;
                    } else if (type == "office") {
                      // text1 = x.location_size + "万方";
                    } else if (type == "company") {
                      // text1 = x.location_size + "亿元";
                    }

                    that.addCallout(
                      dot,
                      text,
                      fillColor,
                      colorPriorityMap[fillColor] || zIndex,
                      isTopLevel ? 26 : 22,
                      text1,
                      undefined,
                      type === "company" || type === "office"
                        ? "mi-enterprise-callout"
                        : ""
                    );
                  }
                });

              if (type === "traffic" && Object.keys(lineMap).length) {
                that.querySubway(Object.keys(lineMap).join("|"));
              }

              for (let i = 8; i > 0; i--) {
                that.addBackCircle(that.center, i * 1000, true);
              }

              that.setMapDataLoad();
            }, 200);
          }
        });
    },
    formatPrice(num) {
      let res = "";
      if (num >= 20000) {
        res = "2w+";
      } else if (num >= 10000) {
        res = "1-2w";
      } else if (num >= 5000) {
        res = "0.5-1w";
      } else if (num > 0) {
        res = "0-0.5w";
      }
      return res || "无";
    },
    formatKey(num) {
      let res = "";
      if (num >= 20) {
        res = "20万方+";
      } else if (num >= 10) {
        res = "10万方+";
      } else if (num >= 5) {
        res = "5万方+";
      } else {
        res = "5万方以下";
      }
      return res;
    },
    querySubway(lines) {
      let that = this;
      let currentMap = amapManager.getMap();
      that.$axios
        .get(that.urlPrefix + "screenshot/data/subway", {
          params: {
            subway: lines,
          },
        })
        .then((res) => {
          that.drawSubway(res.data.data);
        });
    },
    drawSubway(subways, options) {
      let currentMap = amapManager.getMap();
      let that = this;
      const drawOptions = options || {};
      for (let m = 0; m < subways.length; m++) {
        let loc = subways[m];
        that.addSubwayLines(loc);
        let station = JSON.parse(loc.station || "[]");
        let mark = loc.mark
          .split("-")
          .filter((item, index) => index % 3 === 0)
          .filter((x) => x);

        let name_color = "#000000";
        if (loc.name === "1号线") {
          name_color = "#ffffff";
        }
        if (drawOptions.whiteLineLabelText) {
          name_color = "#FFFFFF";
        }
        for (let i = 0; i < mark.length; i++) {
          let text = new AMap.Text({
            zIndex: 12,
            text: that.subwayName[loc.name],
            textAlign: "center",
            verticalAlign: "middle",
            style: {
              "background-color": that.subwayColor[loc.name],
              "border-width": 0,
              "font-size": "20px",
              "line-height": "20px",
              color: name_color,
            },
            position: mark[i].split("|"),
          });
          text.setMap(currentMap);
        }
        for (let i = 0; i < station.length; i++) {
          let markerContent = `
                <div class="stationIcon1" style="background-color:${
                  that.subwayColor[loc.name]
                };">
                  <div></div>
                </div>
                `;
          const marker = new AMap.Marker({
            zIndex: 9,
            position: station[i].position,
            content: markerContent,
            offset: new AMap.Pixel(-10, -10),
          });
          marker.setMap(currentMap);
        }
      }
    },
    addSubwayLines(loc) {
      let that = this;
      let currentMap = amapManager.getMap();
      let dots = loc.dots.split("-").map((x) => {
        return x.split("|");
      });
      let paths = [];
      if (loc.name === "6号线") {
        paths.push({
          style: "dashed",
          path: dots.slice(0, 97),
        });
        paths.push({
          style: "solid",
          path: dots.slice(97),
        });
      } else if (loc.name === "7号线") {
        paths.push({
          style: "dashed",
          path: dots.slice(0, 80),
        });
        paths.push({
          style: "solid",
          path: dots.slice(80),
        });
      } else if (loc.name === "5号线") {
        paths.push({
          style: "solid",
          path: dots.slice(0, 391),
        });
        paths.push({
          style: "dashed",
          path: dots.slice(391),
        });
      } else if (loc.name === "12号线") {
        paths.push({
          style: "dashed",
          path: dots.slice(0, 2),
        });
        paths.push({
          style: "solid",
          path: dots.slice(2, 37),
        });
        paths.push({
          style: "dashed",
          path: dots.slice(37),
        });
      } else if (loc.name === "9号线") {
        paths.push({
          style: "dashed",
          path: dots.slice(0, 82),
        });
        paths.push({
          style: "solid",
          path: dots.slice(82, 179),
        });
        paths.push({
          style: "dashed",
          path: dots.slice(179),
        });
      } else if (loc.name === "4号线") {
        paths.push({
          style: "solid",
          path: dots.slice(0, 152),
        });
        paths.push({
          style: "dashed",
          path: dots.slice(152),
        });
      } else {
        paths = [
          {
            style: that.subwayStatus[loc.name] || "dashed",
            path: dots,
          },
        ];
      }
      for (let p = 0; p < paths.length; p++) {
        let polyline = new AMap.Polyline({
          path: paths[p].path,
          strokeWeight: 3, // 线条宽度，默认为 1
          strokeDasharray: [12, 6],
          strokeStyle: paths[p].style, //线条样式
          strokeColor: that.subwayColor[loc.name], // 线条颜色
          strokeOpacity: 1,
          lineJoin: "round", // 折线拐点连接处样式
        });
        currentMap.add(polyline);
      }
    },

    isLocationV2Type(type) {
      // 与 screenshot 项目的任务类型保持一致。
      return [
        "location_v2_overview",
        "location_v2_commute",
        "location_v2_family",
        "location_v2_elderly",
        "location_v2_pet",
        "location_v2_basic",
      ].includes(type);
    },
    isAreaFacilityType(type) {
      return [
        "area_facility_overview",
        "area_facility_traffic",
        "area_facility_school",
        "area_facility_commerce",
        "area_facility_hospital",
        "area_facility_landscape",
        "area_facility_culture",
      ].includes(type);
    },
    isAreaEvaluationType(type) {
      return type === "area_evaluation";
    },
    isAreaIndustryType(type) {
      return [
        "area_industry_salary",
        "area_industry_company",
        "area_industry_office",
      ].includes(type);
    },
    getAreaIndustryModuleType(type) {
      const typeMap = {
        area_industry_salary: "salary",
        area_industry_company: "company",
        area_industry_office: "office",
      };
      return typeMap[type] || "";
    },
    async areaEvaluationMap(id) {
      try {
        const res = await this.$axios.post(
          this.urlPrefix + "screenshot/data/area-evaluation",
          { id: id }
        );
        const data = res.data && res.data.data;
        const center = this.parseMapLnglat(data && data.center);
        if (!res.data.success || !center) {
          this.setMapDataLoad();
          return;
        }

        this.zoom = 13;
        this.center = center;
        const currentMap = amapManager.getMap();
        currentMap.setZoomAndCenter(this.zoom, this.center);

        let timer = setTimeout(() => {
          clearTimeout(timer);
          try {
            if (!this.drawAreaBoundary(currentMap, data.boundary)) {
              throw new Error("板块边界数据无效");
            }
            const facilityPoints = Array.isArray(data.facility_points)
              ? data.facility_points
              : [];
            this.getLocationV2GridDots(facilityPoints, currentMap).forEach(
              (item) => {
                const position = this.parseMapLnglat(item.lnglat);
                if (position) {
                  this.addDot16px(position, "#FFBB00");
                }
              }
            );
            const industryPoints = Array.isArray(data.industry_points)
              ? data.industry_points
              : [];
            this.getLocationV2GridDots(industryPoints, currentMap).forEach(
              (item) => {
                const position = this.parseMapLnglat(item.lnglat);
                if (position) {
                  this.addDot16px(position, "#55ADFF");
                }
              }
            );
            this.finishCenteredMapLoad(currentMap);
          } catch (error) {
            console.error("areaEvaluationMap render error", error);
            this.setMapDataLoad();
          }
        }, 200);
      } catch (error) {
        console.error("areaEvaluationMap error", error);
        this.setMapDataLoad();
      }
    },
    async areaIndustryMap(id, type) {
      try {
        const res = await this.$axios.post(
          this.urlPrefix + "screenshot/data/area-industry",
          {
            id: id,
            type: type,
          }
        );
        const data = res.data && res.data.data;
        const area = data && data.area;
        const center = this.parseMapLnglat(area && area.lnglat);
        const moduleType = this.getAreaIndustryModuleType(type);
        if (!res.data.success || !center || !moduleType) {
          this.setMapDataLoad();
          return;
        }

        this.zoom = 13;
        this.center = center;
        const currentMap = amapManager.getMap();
        currentMap.setZoomAndCenter(this.zoom, this.center);

        let timer = setTimeout(() => {
          clearTimeout(timer);
          try {
            if (!this.drawAreaBoundary(currentMap, area.boundary)) {
              throw new Error("板块边界数据无效");
            }
            if (moduleType === "salary") {
              const locations = Array.isArray(data.locations)
                ? data.locations
                : [];
              this.renderEmploymentMassMarks(currentMap, locations, this.zoom);
            } else {
              const dotMarkers = Array.isArray(data.dot_markers)
                ? data.dot_markers
                : [];
              this.getLocationV2GridDots(dotMarkers, currentMap).forEach(
                (marker) => {
                  this.drawAreaIndustryDot(marker, moduleType);
                }
              );
              const markers = Array.isArray(data.markers) ? data.markers : [];
              markers.forEach((marker) => {
                this.drawAreaIndustryMarker(marker, moduleType);
              });
            }
            this.finishCenteredMapLoad(currentMap);
          } catch (error) {
            console.error("areaIndustryMap render error", error);
            this.setMapDataLoad();
          }
        }, 200);
      } catch (error) {
        console.error("areaIndustryMap error", error);
        this.setMapDataLoad();
      }
    },
    async areaFacilityMap(id, type) {
      try {
        const res = await this.$axios.post(
          this.urlPrefix + "screenshot/data/area-facility",
          {
            id: id,
            type: type,
          }
        );
        const data = res.data && res.data.data;
        const center = this.parseMapLnglat(data && data.center);
        if (!res.data.success || !center) {
          this.setMapDataLoad();
          return;
        }

        this.zoom = 13;
        this.center = center;
        const currentMap = amapManager.getMap();
        currentMap.setZoomAndCenter(this.zoom, this.center);

        let timer = setTimeout(() => {
          clearTimeout(timer);
          try {
            if (!this.drawAreaBoundary(currentMap, data.boundary)) {
              throw new Error("板块边界数据无效");
            }
            const dots = Array.isArray(data.dots) ? data.dots : [];
            this.getLocationV2GridDots(dots, currentMap).forEach((item) => {
              const position = this.parseMapLnglat(item.lnglat);
              if (position) {
                this.addDotCircle(
                  position,
                  80,
                  type === "area_facility_overview"
                    ? this.getAreaFacilityColor(item.facility_type)
                    : "#FFEB1A"
                );
              }
            });
            const markers = Array.isArray(data.markers) ? data.markers : [];
            markers.forEach((item) => {
              const position = this.parseMapLnglat(item.lnglat);
              if (!position) {
                return;
              }
              if (type === "area_facility_overview") {
                this.addDotCircle(
                  position,
                  80,
                  this.getAreaFacilityColor(item.facility_type)
                );
                return;
              }
              this.addCallout(
                position,
                item.name,
                "#FFEB1A",
                40,
                20,
                "",
                "#333333",
                "mi-area-callout"
              );
            });
            const subways = Array.isArray(data.subways) ? data.subways : [];
            if (subways.length) {
              this.drawSubway(subways, { whiteLineLabelText: true });
            }
            this.drawAreaSubwayStations(data.subway_stations, type);
            this.finishCenteredMapLoad(currentMap);
          } catch (error) {
            console.error("areaFacilityMap render error", error);
            this.setMapDataLoad();
          }
        }, 200);
      } catch (error) {
        console.error("areaFacilityMap error", error);
        this.setMapDataLoad();
      }
    },
    getAreaFacilityColor(type) {
      const colorMap = {
        traffic: "#FEEA69",
        school: "#FFA623",
        commerce: "#55ADFF",
        hospital: "#3DC410",
        landscape: "#FF612C",
        culture: "#00CEC3",
      };
      return colorMap[type] || "#64748B";
    },
    // 统一绘制板块边界，并将完整边界纳入截图视野。
    drawAreaBoundary(currentMap, boundary) {
      const path = String(boundary || "")
        .split("-")
        .map((item) => item.split("|").map(Number))
        .filter(
          (point) =>
            point.length === 2 &&
            Number.isFinite(point[0]) &&
            Number.isFinite(point[1])
        );
      if (path.length < 3) {
        return null;
      }
      const polygon = new AMap.Polygon({
        path,
        fillColor: "#FDAB47",
        fillOpacity: 0.2,
        strokeColor: "#FCA130",
        strokeOpacity: 1,
        strokeWeight: 2,
        strokeStyle: "dashed",
        strokeDasharray: [10, 6],
        lineJoin: "round",
        zIndex: 5,
      });
      currentMap.add(polygon);
      currentMap.setFitView([polygon], false, [24, 24, 24, 24]);
      const mapCenter = currentMap.getCenter();
      this.zoom = currentMap.getZoom();
      this.center = [mapCenter.getLng(), mapCenter.getLat()];
      return polygon;
    },
    // 交通详情显示全部站名气泡，总览仍使用交通分类点。
    drawAreaSubwayStations(stations, type) {
      const list = Array.isArray(stations) ? stations : [];
      list.forEach((station) => {
        const position = this.parseMapLnglat(station && station.lnglat);
        if (!position) {
          return;
        }
        if (type === "area_facility_overview") {
          this.addDotCircle(position, 80, this.getAreaFacilityColor("traffic"));
          return;
        }
        this.addCallout(
          position,
          station.name || "地铁站",
          "#FFEB1A",
          40,
          20,
          "",
          "#333333",
          "mi-area-callout"
        );
      });
    },
    drawAreaIndustryDot(marker, type) {
      const position = this.parseMapLnglat(marker && marker.lnglat);
      if (!position) return null;
      if (type === "company") return this.addDotCircle(position, 90, "#AB82FF");
      const size = Math.max(
        70,
        Math.min(180, Number(marker.location_size || 0) * 3)
      );
      return this.addDotCircle(position, size, "#FFA52D");
    },
    drawAreaIndustryMarker(marker, type) {
      const position = this.parseMapLnglat(marker && marker.lnglat);
      if (!position) return null;
      return this.addCallout(
        position,
        marker.display_name || marker.location_name || marker.name,
        "#FFEB1A",
        40,
        20,
        "",
        "#333333",
        "mi-area-callout"
      );
    },
    // 三类因素截图共用同一套数据入口，但展示密度不同。
    isEstateFactorType(type) {
      return [
        "estate_factor_all",
        "estate_factor_unfavorable",
        "estate_factor_favorable",
      ].includes(type);
    },
    // scope 只控制截图内容，不在页面中增加切换控件。
    getEstateFactorScope(type) {
      const scopes = {
        estate_factor_all: "all",
        estate_factor_unfavorable: "unfavorable",
        estate_factor_favorable: "favorable",
      };
      return scopes[type] || "all";
    },
    // 按首页、不利详情和有利详情分别绘制设计稿规定的地图内容。
    async estateFactorMap(estateId, type) {
      try {
        const scope = this.getEstateFactorScope(type);
        const res = await this.$axios.post(
          this.urlPrefix + "screenshot/data/estate-factors",
          {
            estate_id: estateId,
            scope: scope,
          }
        );
        const data = res.data && res.data.data;
        const estate = data && data.estate;
        const center = estate
          ? [Number(estate.longitude), Number(estate.latitude)]
          : null;
        if (
          !res.data.success ||
          !center ||
          !Number.isFinite(center[0]) ||
          !Number.isFinite(center[1])
        ) {
          this.setMapDataLoad();
          return;
        }

        this.center = center;
        const currentMap = amapManager.getMap();
        currentMap.setZoomAndCenter(14, center);
        const overlays = [this.addEstateIcon(center)];
        this.getEstateFactorRangeRadii(scope).forEach((radius) => {
          overlays.push(this.addGreenRangeCircle(center, radius));
          overlays.push(this.addEstateFactorRangeLabel(center, radius));
        });
        const points = Array.isArray(data.points) ? data.points : [];
        points.forEach((point) => {
          const position = [Number(point.longitude), Number(point.latitude)];
          if (!Number.isFinite(position[0]) || !Number.isFinite(position[1])) {
            return;
          }

          const color = this.getEstateFactorColor(point, scope);
          overlays.push(
            this.addCallout(
              position,
              this.escapeEstateFactorText(
                point.name || this.getEstateFactorTypeName(point.type)
              ),
              color,
              point.polarity === "unfavorable" ? 50 : 40,
              22,
              "",
              scope === "favorable" || point.polarity === "favorable"
                ? "#333333"
                : "#fff",
              "mi-estate-factor-callout"
            )
          );
        });
        this.finishEstateFactorMapLoad(currentMap, scope);
      } catch (error) {
        console.error("estateFactorMap error", error);
        this.setMapDataLoad();
      }
    },
    // 规划资讯地图只消费定时任务已经计算好的 3km 地图缓存。
    async planningNewsMap(estateId) {
      try {
        const res = await this.$axios.post(
          this.urlPrefix + "screenshot/data/planning-news",
          { estate_id: estateId }
        );
        const data = res.data && res.data.data;
        if (
          !res.data.success ||
          !data ||
          !Number.isFinite(data.longitude) ||
          !Number.isFinite(data.latitude) ||
          !Array.isArray(data.points)
        ) {
          this.setMapDataLoad();
          return;
        }

        this.center = [data.longitude, data.latitude];
        const currentMap = amapManager.getMap();
        currentMap.setZoomAndCenter(14, this.center);
        this.addEstateIcon(this.center);

        let outerCircle = null;
        [1000, 2000, 3000].forEach((radius) => {
          const circle = this.addGreenRangeCircle(this.center, radius);
          this.addEstateFactorRangeLabel(this.center, radius);
          if (radius === 3000) outerCircle = circle;
        });

        data.points.forEach((point) => {
          const color = this.getPlanningNewsColor(point.direction);
          const text = this.escapeEstateFactorText(
            `${point.name}（${point.status}）`
          );
          this.addCallout(
            [point.longitude, point.latitude],
            text,
            color,
            40,
            20,
            "",
            "#ffffff",
            "mi-planning-news-callout"
          );
        });
        this.finishPlanningNewsMapLoad(currentMap, outerCircle);
      } catch (error) {
        console.error("planningNewsMap error", error);
        this.setMapDataLoad();
      }
    },
    // 规划资讯方向只映射设计稿指定的两个背景色。
    getPlanningNewsColor(direction) {
      const colorMap = {
        负面: "#FF612C",
        利好: "#3DC410",
      };
      return colorMap[direction];
    },
    // 只按 3km 外圈固定截图视野，不让范围外资讯影响缩放。
    finishPlanningNewsMapLoad(currentMap, outerCircle) {
      let finished = false;
      let loadTimer;
      const finishLoad = () => {
        if (finished) return;
        finished = true;
        clearTimeout(loadTimer);
        currentMap.off("tilesloaded", finishLoad);
        this.setMapDataLoad();
      };

      currentMap.on("tilesloaded", finishLoad);
      loadTimer = setTimeout(finishLoad, 1000);
      if (outerCircle) {
        currentMap.setFitView([outerCircle], false, [40, 40, 40, 40]);
      }
    },
    // 因素截图的虚线圈表达设计稿中的空间尺度。
    getEstateFactorRangeRadii(scope) {
      return scope === "favorable" ? [1000, 2000, 3000] : [500, 1000];
    },
    // 新版截图统一使用无填充的绿色虚线圈，避免复用旧范围圈样式。
    addGreenRangeCircle(center, radius) {
      const circle = new AMap.Circle({
        center: center,
        radius: radius,
        fillOpacity: 0,
        strokeColor: "#51b86b",
        strokeOpacity: 0.7,
        strokeWeight: 2,
        strokeStyle: "dashed",
        zIndex: 5,
      });
      const currentMap = amapManager.getMap();
      currentMap.add(circle);
      return circle;
    },
    // 距离气泡放在范围圈正北侧，箭头与圆周边界对齐。
    addEstateFactorRangeLabel(center, radius) {
      const kilometers = radius / 1000;
      const text = radius < 1000 ? `${radius}米` : `${kilometers}公里`;
      const latitude =
        Number(center[1]) + Number(((360 / 40000) * kilometers).toFixed(6));
      const marker = new AMap.Marker({
        position: [Number(center[0]), latitude],
        content: `<div class="mi-estate-factor-distance-callout">${text}</div>`,
        offset: new AMap.Pixel(0, 10),
        anchor: "bottom-center",
        zIndex: 8,
      });
      const currentMap = amapManager.getMap();
      marker.setMap(currentMap);
      return marker;
    },
    // 地图调整视野后等待瓦片完成，超时只作为截图任务的降级出口。
    finishEstateFactorMapLoad(currentMap, scope) {
      let finished = false;
      let loadTimer;
      const finishLoad = () => {
        if (finished) {
          return;
        }
        finished = true;
        clearTimeout(loadTimer);
        currentMap.off("tilesloaded", finishLoad);
        this.setMapDataLoad();
      };

      currentMap.on("tilesloaded", finishLoad);
      loadTimer = setTimeout(finishLoad, 1000);
      // 有利详情缩小一档保证 3km 虚线圈完整可见，其余两类固定 15 级。
      currentMap.setZoomAndCenter(scope === "favorable" ? 14 : 15, this.center);
    },
    // 有利因素使用黄色，不利因素按关注等级使用指定配色。
    getEstateFactorColor(point, scope) {
      if (scope === "favorable" || point.polarity === "favorable") {
        return "#fddd25";
      }
      const colors = {
        明显影响: "#FF612C",
        一般影响: "#ffa623",
        轻微影响: "#3DC410",
      };
      return colors[point.attention_level] || "#8c9aa8";
    },
    // 无实体名称的点位由因素类型映射前端名称。
    getEstateFactorTypeName(type) {
      const names = {
        aircraft_noise: "机场跑道或航线",
        railway: "铁路或高铁",
        expressway_elevated: "高速、快速路或高架",
      };
      return names[type] || "周边因素";
    },
    // 接口名称进入自定义 HTML 前先转义，避免破坏气泡结构。
    escapeEstateFactorText(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    isEnterpriseOfficeValueType(type) {
      // company、office 沿用原截图类型，但数据和样式来自新价值评测。
      return ["company", "office"].includes(type);
    },
    finishCenteredMapLoad(currentMap) {
      let finished = false;
      let loadTimer;
      const finishLoad = () => {
        if (finished) {
          return;
        }
        finished = true;
        clearTimeout(loadTimer);
        currentMap.off("tilesloaded", finishLoad);
        this.setMapDataLoad();
      };

      currentMap.on("tilesloaded", finishLoad);
      loadTimer = setTimeout(finishLoad, 1000);
      // 标记渲染后再次锁定楼盘中心，避免其他覆盖物改变视口。
      currentMap.setZoomAndCenter(this.zoom, this.center);
    },
    async enterpriseOfficeValueMap(estate_id, type) {
      try {
        const res = await this.$axios.post(
          this.urlPrefix + "screenshot/data/value-enterprise-office",
          {
            estate_id: estate_id,
            type: type,
          }
        );
        const data = res.data && res.data.data;
        const center = this.parseMapLnglat(
          data && data.estate && data.estate.lnglat
        );
        if (!res.data.success || !center) {
          this.setMapDataLoad();
          return;
        }

        this.zoom = 13;
        this.center = center;
        const currentMap = amapManager.getMap();
        currentMap.setZoomAndCenter(this.zoom, this.center);

        let timer = setTimeout(() => {
          clearTimeout(timer);
          try {
            // 保留原企业办公截图的楼盘标记和8公里距离圈。
            this.addCallout(
              this.center,
              "本楼盘",
              "FF612C",
              60,
              26,
              "",
              "#fff",
              "mi-enterprise-callout"
            );
            const dotMarkers = Array.isArray(data.dot_markers)
              ? data.dot_markers
              : [];
            this.getLocationV2GridDots(dotMarkers, currentMap).forEach(
              (marker) => {
                this.drawEnterpriseOfficeValueDot(marker, type);
              }
            );
            const markers = Array.isArray(data.markers) ? data.markers : [];
            markers.forEach((marker) => {
              this.drawEnterpriseOfficeValueMarker(marker, type);
            });
            for (let radius = 8; radius > 0; radius--) {
              this.addBackCircle(this.center, radius * 1000, true);
            }
            this.finishCenteredMapLoad(currentMap);
          } catch (error) {
            console.error("enterpriseOfficeValueMap render error", error);
            this.setMapDataLoad();
          }
        }, 200);
      } catch (error) {
        console.error("enterpriseOfficeValueMap error", error);
        this.setMapDataLoad();
      }
    },
    getEnterpriseOfficeValueStyle(marker, type) {
      // 新数据沿用原企业和写字楼截图的颜色、字号及层级。
      if (type === "company") {
        const companyStyles = {
          上市: {
            color: "#FFA52D",
            zIndex: 30,
            fontSize: 26,
          },
          重要: {
            color: "#6A9DFF",
            zIndex: 29,
            fontSize: 22,
          },
        };
        return (
          companyStyles[marker && marker.school_type] || {
            color: "#73bdf3",
            zIndex: 20,
            fontSize: 22,
          }
        );
      }

      const size = Number(marker && marker.location_size);
      if (size >= 20) {
        return {
          color: "#FFA52D",
          zIndex: 30,
          fontSize: 26,
        };
      }
      if (size >= 10) {
        return {
          color: "#6A9DFF",
          zIndex: 29,
          fontSize: 22,
        };
      }
      if (size >= 5) {
        return {
          color: "#AB82FF",
          zIndex: 28,
          fontSize: 22,
        };
      }
      return {
        color: "#FFD2A2",
        zIndex: 27,
        fontSize: 22,
      };
    },
    drawEnterpriseOfficeValueMarker(marker, type) {
      const position = this.parseMapLnglat(marker && marker.lnglat);
      if (!position) {
        return null;
      }
      const style = this.getEnterpriseOfficeValueStyle(marker, type);
      return this.addCallout(
        position,
        marker.display_name || marker.location_name || marker.name,
        style.color,
        style.zIndex,
        style.fontSize,
        "",
        undefined,
        "mi-enterprise-callout"
      );
    },
    drawEnterpriseOfficeValueDot(marker, type) {
      const position = this.parseMapLnglat(marker && marker.lnglat);
      if (!position) {
        return null;
      }
      const style = this.getEnterpriseOfficeValueStyle(marker, type);
      return this.addDotCircle(position, 100, style.color);
    },
    async locationV2Map(estate_id, type) {
      try {
        const shouldDrawSubway = [
          "location_v2_overview",
          "location_v2_commute",
        ].includes(type);
        const subwayRequest = shouldDrawSubway
          ? this.$axios
              .get(this.urlPrefix + "screenshot/data/location", {
                params: {
                  estate_id: estate_id,
                  distance: type === "location_v2_overview" ? 3000 : 1000,
                },
              })
              .catch((error) => {
                console.error("locationV2Map subway error", error);
                return null;
              })
          : Promise.resolve(null);
        const [res, subwayRes] = await Promise.all([
          this.$axios.post(this.urlPrefix + "screenshot/data/location-v2", {
            estate_id: estate_id,
            type: type,
          }),
          subwayRequest,
        ]);
        const data = res.data && res.data.data;
        const center = this.parseMapLnglat(
          data && data.estate && data.estate.lnglat
        );
        if (!res.data.success || !center) {
          this.setMapDataLoad();
          return;
        }
        const subwayData =
          subwayRes && subwayRes.data && subwayRes.data.success
            ? subwayRes.data.data
            : null;
        const subwayList =
          subwayData && Array.isArray(subwayData.subwayList)
            ? subwayData.subwayList
            : [];

        this.zoom = type === "location_v2_overview" ? 14 : 15;
        this.center = center;
        const currentMap = amapManager.getMap();
        currentMap.setZoomAndCenter(this.zoom, this.center);

        let timer = setTimeout(() => {
          clearTimeout(timer);
          try {
            this.addEstateIcon(this.center);
            const originalMarkers = Array.isArray(data.markers)
              ? data.markers
              : [];
            const subwayStationMarkers = this.getLocationV2CommuteSubwayMarkers(
              type,
              subwayData
            );
            const markers = this.mergeLocationV2Markers(
              originalMarkers,
              subwayStationMarkers
            );
            const dotMarkers = this.filterLocationV2SubwayDots(
              Array.isArray(data.dot_markers) ? data.dot_markers : [],
              subwayStationMarkers
            );
            this.getLocationV2GridDots(dotMarkers, currentMap).forEach(
              (marker) => {
                this.drawLocationV2Dot(marker);
              }
            );
            markers.forEach((marker) => {
              this.drawLocationV2Marker(marker);
            });
            if (subwayList.length > 0) {
              this.drawSubway(subwayList);
            }
            // 配套截图保持原缩放，只叠加1、2、3公里空间参照圈。
            [1000, 2000, 3000].forEach((radius) => {
              this.addGreenRangeCircle(this.center, radius);
            });
            this.finishCenteredMapLoad(currentMap);
          } catch (error) {
            console.error("locationV2Map render error", error);
            this.setMapDataLoad();
          }
        }, 200);
      } catch (error) {
        console.error("locationV2Map error", error);
        this.setMapDataLoad();
      }
    },
    drawLocationV2Marker(marker) {
      const position = this.parseMapLnglat(marker && marker.lnglat);
      if (!position) {
        return null;
      }
      return this.addCallout(
        position,
        marker.display_name || marker.location_name || marker.name,
        "#FCDE3E",
        marker.priority === "important" ? 40 : 30,
        20,
        "",
        "#333333",
        "mi-location-v2-callout"
      );
    },
    getLocationV2PositionKey(marker) {
      const position = this.parseMapLnglat(marker && marker.lnglat);
      if (!position) {
        return "";
      }
      return `${position[0].toFixed(6)}|${position[1].toFixed(6)}`;
    },
    getLocationV2CommuteSubwayMarkers(type, subwayData) {
      if (
        type !== "location_v2_commute" ||
        !subwayData ||
        !Array.isArray(subwayData.trafficList)
      ) {
        return [];
      }
      return subwayData.trafficList
        .filter(
          (marker) =>
            marker &&
            marker.school_type === "地铁" &&
            this.getLocationV2PositionKey(marker)
        )
        .map((marker) => ({
          ...marker,
          display_name:
            marker.location_name ||
            marker.display_name ||
            marker.name ||
            "地铁站",
        }));
    },
    mergeLocationV2Markers(markers, extraMarkers) {
      const result = markers.slice();
      const positionKeys = new Set(
        markers
          .map((marker) => this.getLocationV2PositionKey(marker))
          .filter((key) => key)
      );
      extraMarkers.forEach((marker) => {
        const positionKey = this.getLocationV2PositionKey(marker);
        if (!positionKey || positionKeys.has(positionKey)) {
          return;
        }
        positionKeys.add(positionKey);
        result.push(marker);
      });
      return result;
    },
    filterLocationV2SubwayDots(markers, subwayStationMarkers) {
      const subwayStationPositionKeys = new Set(
        subwayStationMarkers
          .map((marker) => this.getLocationV2PositionKey(marker))
          .filter((key) => key)
      );
      return markers.filter(
        (marker) =>
          !subwayStationPositionKeys.has(this.getLocationV2PositionKey(marker))
      );
    },

    getLocationV2GridDots(markers, currentMap) {
      const gridSize = 40;
      const occupiedGrids = new Set();
      const result = [];

      markers.forEach((marker) => {
        const position = this.parseMapLnglat(marker && marker.lnglat);
        if (!position) {
          return;
        }
        const pixel = currentMap.lngLatToContainer(position);
        const x = Number(pixel && pixel.x);
        const y = Number(pixel && pixel.y);
        if (!Number.isFinite(x) || !Number.isFinite(y)) {
          return;
        }
        const gridKey = `${Math.floor(x / gridSize)}_${Math.floor(
          y / gridSize
        )}`;
        if (occupiedGrids.has(gridKey)) {
          return;
        }
        occupiedGrids.add(gridKey);
        result.push(marker);
      });

      return result;
    },
    drawLocationV2Dot(marker) {
      const position = this.parseMapLnglat(marker && marker.lnglat);
      if (!position) {
        return null;
      }
      const currentMap = amapManager.getMap();
      const dot = new AMap.Marker({
        position: position,
        content: '<div class="mi-location-v2-dot"></div>',
        offset: new AMap.Pixel(0, 0),
        anchor: "center",
        zIndex: 10,
      });
      dot.setMap(currentMap);
      return dot;
    },
    parseMapLnglat(lnglat) {
      const position = String(lnglat || "")
        .split("-")[0]
        .split("|")
        .map(Number);
      if (
        position.length !== 2 ||
        !Number.isFinite(position[0]) ||
        !Number.isFinite(position[1])
      ) {
        return null;
      }
      return position;
    },

    locationMap(estate_id) {
      let that = this;
      that.$axios
        .get(that.urlPrefix + "screenshot/data/location", {
          params: {
            estate_id: estate_id,
          },
        })
        .then((res) => {
          this.zoom = 14;
          let data = res.data.data;
          that.center = data.realEstate.lnglat.split("-")[0].split("|");
          let timer = setTimeout(() => {
            clearTimeout(timer);

            that.addCallout();
            let subwayList = data.subwayList || [];
            let sObj = data.schoolObj;
            let array2 = sObj["幼儿园"] || [];
            let array3 = sObj["小学"] || [];
            let array4 = sObj["中学"] || [];
            let dataList1 = data.trafficList || [];
            let dataList2 = data.marketList || [];
            let dataList3 = data.hospitalList || [];
            let dataList4 = data.sceneryList || [];
            let dataList5 = data.publicList || [];
            let dataList6 = data.harmfulList || [];
            let mapList = dataList1
              .concat(array2)
              .concat(array3)
              .concat(array4)
              .concat(dataList2)
              .concat(dataList3)
              .concat(dataList4)
              .concat(dataList5)
              .concat(dataList6);
            for (let i = 0; i < mapList.length; i++) {
              let oneMap = mapList[i];
              if (!oneMap || !oneMap.lnglat) {
                continue;
              }
              let location_name = "";
              let Ltype = oneMap.location_type;
              let zIndex = 1;
              let bgColor = "";
              if (oneMap.school_type === "不利") {
                bgColor = "#EFECFF";
                location_name = "不利";
                zIndex = 4;
              } else if (Ltype === "学校") {
                bgColor = "#FFF2AF";
                if (oneMap.location_degree === "重点") {
                  location_name = oneMap.location_name;
                  zIndex = 4;
                } else {
                  location_name = "学";
                }
              } else if (Ltype === "交通") {
                bgColor = "#EEEEEE";
                location_name = oneMap.location_name;
                zIndex = 4;
              } else if (Ltype === "商场") {
                bgColor = "#FFDEB2";
                if (oneMap.location_degree === "重点") {
                  location_name = oneMap.location_name;
                  zIndex = 4;
                } else {
                  location_name = "商";
                }
              } else if (Ltype === "医院") {
                bgColor = "#FFEBE5";
                if (oneMap.location_degree === "重点") {
                  location_name = oneMap.location_name;
                  zIndex = 4;
                } else {
                  location_name = "医";
                }
              } else if (Ltype === "周边景观") {
                bgColor = "#B2F1A7";
                if (oneMap.location_degree === "重点") {
                  location_name = oneMap.location_name;
                  zIndex = 4;
                } else {
                  location_name = "景";
                }
              } else if (Ltype === "公共配套") {
                bgColor = "#E2E9FF";
                if (oneMap.location_degree === "重点") {
                  location_name = oneMap.location_name;
                  zIndex = 4;
                } else {
                  location_name = "文";
                }
              }
              if (location_name)
                that.addCallout(
                  oneMap.lnglat.split("|"),
                  location_name,
                  bgColor,
                  zIndex + 10,
                  zIndex == 4 ? 26 : 20,
                  "",
                  "#333333"
                );
            }

            if (subwayList.length > 0) {
              that.drawSubway(subwayList);
            }

            // 3个圈
            for (let i = 3; i > 0; i--) {
              that.addBackCircle(that.center, i * 1000, true);
            }

            that.setMapDataLoad();
          }, 200);
        });
    },
    async vrMap(estate_id) {
      let that = this;
      let res = await that.$axios.get(that.urlPrefix + "screenshot/data/vrs", {
        params: { estate_id: estate_id },
      });
      let data = res.data.data;
      that.center = data.lnglat.split("-")[0].split("|");
      let timer = setTimeout(() => {
        that.zoom = 17;
        clearTimeout(timer);
        that.addCallout();
        for (let i = 0; i < data.list.length; i++) {
          let oneMap = data.list[i];
          if (!oneMap || !oneMap.lnglat) continue;
          that.addDotCircle(oneMap.lnglat.split("|"), 9, "#FFA52D");
        }

        that.setMapDataLoad();
      }, 200);
    },
    clearEmploymentMassMarks() {
      if (this._employmentMassMarks) {
        this._employmentMassMarks.setMap(null);
        this._employmentMassMarks = null;
      }
    },
    buildSalaryIconStyle(iconPath, size) {
      size = size || 11;
      return {
        url: iconPath,
        size: new AMap.Size(size, size),
        anchor: new AMap.Pixel(size / 2, size / 2),
      };
    },
    getSalaryLevelConfig() {
      if (this._salaryLevelConfig) {
        return this._salaryLevelConfig;
      }
      const salaryLevels = [
        "below_10k",
        "10k_to_20k",
        "20k_to_30k",
        "30k_to_50k",
        "above_50k",
      ];
      const salaryIconMap = {
        below_10k: "/static/images/10kbrrow.png",
        "10k_to_20k": "/static/images/10-20k.png",
        "20k_to_30k": "/static/images/20-30k.png",
        "30k_to_50k": "/static/images/30-50k.png",
        above_50k: "/static/images/50kupload.png",
      };
      const salaryCoefficientMap = {
        below_10k: 0.4,
        "10k_to_20k": 0.7,
        "20k_to_30k": 1,
        "30k_to_50k": 1.3,
        above_50k: 1.6,
      };
      this._salaryLevelConfig = {
        salaryLevels,
        salaryIconMap,
        salaryCoefficientMap,
      };
      return this._salaryLevelConfig;
    },
    getGridSizeByScale(scale) {
      if (scale >= 16) return 0;
      if (scale >= 14) return 0.004;
      if (scale >= 13) return 0.008;
      if (scale >= 12) return 0.014;
      if (scale >= 11) return 0.022;
      if (scale >= 10) return 0.035;
      return 0.055;
    },
    getClusterDotSize(count) {
      const base = 15;
      if (count <= 1) return base;
      if (count <= 5) return base + 4;
      if (count <= 15) return base + 8;
      if (count <= 40) return base + 12;
      return base + 16;
    },
    getEmploymentClusterZIndex(level, count) {
      const { salaryCoefficientMap } = this.getSalaryLevelConfig();
      const coefficient = salaryCoefficientMap[level] || 0.4;
      return 10 + Math.round(coefficient * 10) + Math.min(count || 1, 20);
    },
    buildClusteredLocations(locations, scale) {
      const MAX_VISIBLE_MARKERS = 900;
      const cellSize = this.getGridSizeByScale(scale);

      if (!cellSize) {
        const limit = Math.min(locations.length, MAX_VISIBLE_MARKERS);
        const result = [];
        for (let i = 0; i < limit; i++) {
          const item = locations[i];
          const longitude = Number(item.longitude);
          const latitude = Number(item.latitude);
          if (!longitude || !latitude) continue;
          const level = item.level || item.salary_level || "below_10k";
          result.push({
            longitude,
            latitude,
            level,
            count: 1,
            zIndex: this.getEmploymentClusterZIndex(level, 1),
          });
        }
        return result;
      }

      const buckets = new Map();
      for (let i = 0; i < locations.length; i++) {
        const item = locations[i];
        const longitude = Number(item.longitude);
        const latitude = Number(item.latitude);
        if (!longitude || !latitude) continue;
        const levelKey = item.level || item.salary_level || "below_10k";
        const gx = Math.floor(longitude / cellSize);
        const gy = Math.floor(latitude / cellSize);
        const key = levelKey + "|" + gx + "|" + gy;
        let bucket = buckets.get(key);
        if (!bucket) {
          bucket = {
            level: levelKey,
            sumLng: 0,
            sumLat: 0,
            count: 0,
          };
          buckets.set(key, bucket);
        }
        bucket.sumLng += longitude;
        bucket.sumLat += latitude;
        bucket.count += 1;
      }

      const result = [];
      buckets.forEach((bucket) => {
        result.push({
          longitude: bucket.sumLng / bucket.count,
          latitude: bucket.sumLat / bucket.count,
          level: bucket.level,
          count: bucket.count,
          zIndex: this.getEmploymentClusterZIndex(bucket.level, bucket.count),
        });
      });

      if (result.length > MAX_VISIBLE_MARKERS) {
        result.sort((a, b) => (b.zIndex || 0) - (a.zIndex || 0));
        return result.slice(0, MAX_VISIBLE_MARKERS);
      }
      return result;
    },
    getOrCreateSalaryDotStyle(level, dotSize) {
      if (!this._salaryDotStyleCache) {
        this._salaryDotStyleCache = {};
        this._salaryDotStyleList = [];
      }
      const key = level + "|" + dotSize;
      if (this._salaryDotStyleCache[key] !== undefined) {
        return this._salaryDotStyleCache[key];
      }
      const { salaryIconMap } = this.getSalaryLevelConfig();
      const iconPath = salaryIconMap[level] || salaryIconMap.below_10k;
      const style = this.buildSalaryIconStyle(iconPath, dotSize);
      const styleIndex = this._salaryDotStyleList.length;
      this._salaryDotStyleList.push(style);
      this._salaryDotStyleCache[key] = styleIndex;
      return styleIndex;
    },
    resolveEmploymentMapCenter(data, locations) {
      if (data.lnglat) {
        return data.lnglat.split("-")[0].split("|").map(Number);
      }
      const estate = data.estate;
      if (estate) {
        if (estate.longitude != null && estate.latitude != null) {
          return [estate.longitude, estate.latitude];
        }
        if (estate.lnglat) {
          return estate.lnglat.split("|").map(Number);
        }
      }
      const center = data.center;
      if (center) {
        if (Array.isArray(center)) {
          return center;
        }
        if (center.longitude != null && center.latitude != null) {
          return [center.longitude, center.latitude];
        }
        if (center.lnglat) {
          return center.lnglat.split("|").map(Number);
        }
      }
      let lngSum = 0;
      let latSum = 0;
      locations.forEach((l) => {
        lngSum += l.longitude;
        latSum += l.latitude;
      });
      return [lngSum / locations.length, latSum / locations.length];
    },
    renderEmploymentMassMarks(currentMap, locations, scale) {
      this.clearEmploymentMassMarks();
      this._salaryDotStyleCache = {};
      this._salaryDotStyleList = [];
      const clustered = this.buildClusteredLocations(
        locations,
        scale || this.zoom || 12
      );
      const massData = clustered.map((item) => {
        const dotSize = this.getClusterDotSize(item.count);
        return {
          lnglat: [item.longitude, item.latitude],
          style: this.getOrCreateSalaryDotStyle(item.level, dotSize),
        };
      });
      const massMarks = new AMap.MassMarks(massData, {
        zIndex: 10,
        opacity: 1,
        cursor: "default",
        style: this._salaryDotStyleList,
      });
      massMarks.setMap(currentMap);
      this._employmentMassMarks = massMarks;
    },
    employmentIncomeMap(id) {
      let that = this;
      that.zoom = 13;
      that.$axios
        .post(that.urlPrefix + "value-analysis/job-income-locations", {
          estate_id: id,
        })
        .then((res) => {
          if (res.data.success) {
            let data = res.data.data || {};
            let locations = data.locations || [];
            if (!locations.length) {
              that.setMapDataLoad();
              return;
            }
            that.center = that.resolveEmploymentMapCenter(data, locations);
            let timer = setTimeout(() => {
              clearTimeout(timer);
              let currentMap = amapManager.getMap();
              try {
                that.renderEmploymentMassMarks(
                  currentMap,
                  locations,
                  that.zoom
                );
              } catch (e) {
                console.warn("mass marks render error", e);
              }
              that.addCallout(
                that.center,
                "本楼盘",
                "FF612C",
                60,
                26,
                "",
                "#fff",
                "mi-enterprise-callout"
              );
              that.addBackCircle(that.center, 3000, true);
              that.addBackCircle(that.center, 8000, true);
              that.finishCenteredMapLoad(currentMap);
            }, 200);
          } else {
            that.setMapDataLoad();
          }
        })
        .catch(() => {
          that.setMapDataLoad();
        });
    },
    storeMap(id) {
      let that = this;
      that.$axios
        .get(that.urlPrefix + "store/getSurroundingStoreInfo", {
          params: {
            estate_id: id,
            distance: 1000,
          },
        })
        .then((res) => {
          if (res.data.success) {
            that.zoom = 15;
            let data = res.data.result;
            console.log(res);
            that.center = data.center.location;
            let timer = setTimeout(() => {
              clearTimeout(timer);
              that.addCallout(
                that.center,
                data.center.estate_name,
                "#4375ff",
                10,
                20
              );

              let markers = data.markers;
              markers.forEach((marker) => {
                that.addCallout(
                  marker.location,
                  marker.estate_name,
                  "#BBD6FF",
                  6
                );
              });

              that.addBackCircle(that.center, 1000, 0, 1);

              that.setMapDataLoad();
            }, 200);
          }
        });
    },

    industryMap(id) {
      let that = this;
      that.$axios
        .get(that.urlPrefix + "store/getSurroundingIndustryInfo", {
          params: {
            estate_id: id,
            distance: 1000,
          },
        })
        .then((res) => {
          if (res.data.success) {
            that.zoom = 15;
            let data = res.data.result;
            console.log(res);
            that.center = data.center.location;
            let timer = setTimeout(() => {
              clearTimeout(timer);
              that.addCallout(
                that.center,
                data.center.estate_name,
                "#4375ff",
                10,
                20
              );

              let markers = data.markers;
              markers.forEach((marker) => {
                that.addCallout(
                  marker.lnglat.split("|"),
                  marker.location_name,
                  "#BBD6FF",
                  6,
                  18
                );
              });

              that.addBackCircle(that.center, 1000, 0, 1);

              that.setMapDataLoad();
            }, 200);
          }
        });
    },
    storeLocationMap(id) {
      let that = this;
      that.$axios
        .get(that.urlPrefix + "screenshot/data/location", {
          params: {
            estate_id: id,
            distance: 1000,
          },
        })
        .then((res) => {
          if (res.data.success) {
            that.zoom = 15;
            let data = res.data.data;
            // console.log(res)
            that.center = data.realEstate.lnglat.split("|");
            let timer = setTimeout(() => {
              clearTimeout(timer);
              that.addCallout(
                that.center,
                data.realEstate.real_estate_name,
                "#4375ff",
                20,
                20
              );

              let subwayList = data.subwayList || [];
              let sObj = data.schoolObj;
              let array2 = sObj["幼儿园"] || [];
              let array3 = sObj["小学"] || [];
              let array4 = sObj["中学"] || [];
              let dataList1 = data.trafficList || [];
              let dataList2 = data.marketList || [];
              let dataList3 = data.hospitalList || [];
              let dataList4 = data.sceneryList || [];
              let dataList5 = data.publicList || [];
              let mapList = dataList1
                .concat(array2)
                .concat(array3)
                .concat(array4)
                .concat(dataList2)
                .concat(dataList3)
                .concat(dataList4)
                .concat(dataList5);
              for (let i = 0; i < mapList.length; i++) {
                let oneMap = mapList[i];
                if (!oneMap || !oneMap.lnglat) {
                  continue;
                }
                let location_name = "";
                let Ltype = oneMap.location_type;
                let zIndex = 1;
                let bgColor = "";
                if (Ltype === "学校") {
                  bgColor = "#BBD6FF";
                  location_name = oneMap.location_name;
                  zIndex = 4;
                } else if (Ltype === "交通") {
                  bgColor = "#FDE247";
                  location_name = oneMap.location_name;
                } else if (Ltype === "商场") {
                  bgColor = "#FBE7CE";
                  location_name = oneMap.location_name;
                  zIndex = 4;
                } else if (Ltype === "医院") {
                  bgColor = "#FFF9DB";
                  location_name = oneMap.location_name;
                  zIndex = 4;
                } else if (Ltype === "周边景观") {
                  bgColor = "#FFD2A2";
                  location_name = oneMap.location_name;
                  zIndex = 4;
                } else if (Ltype === "公共配套") {
                  bgColor = "#E2D4FF";
                  location_name = oneMap.location_name;
                  zIndex = 4;
                }
                that.addCallout(
                  oneMap.lnglat.split("|"),
                  location_name,
                  bgColor,
                  zIndex + 10,
                  18
                );
              }
              if (subwayList.length > 0) {
                that.drawSubway(subwayList);
              }
              that.addBackCircle(that.center, 1000, 0, 1);

              that.setMapDataLoad();
            }, 200);
          }
        });
    },
    locationDensityMap(id) {
      let that = this;
      that.$axios
        .get(that.urlPrefix + "screenshot/data/density", {
          params: {
            estate_id: id,
          },
        })
        .then((res) => {
          if (res.data.success) {
            that.zoom = 15;
            let data = res.data.data;
            console.log(res);
            that.center = data.realEstate.lnglat.split("-")[0].split("|");
            let timer = setTimeout(() => {
              clearTimeout(timer);
              that.addCallout(that.center, null, null, 10, 18, "", "#fff");

              const colorMap = {
                餐饮: "#FFD500",
                购物: "#F69008",
                金融: "#FF4897",
                娱乐: "#BE44DB",
                生活: "#FFF704",
                公建: "#003CFF",
                教育: "#0099FF",
                文化: "#07FFFF",
                医疗: "#00FFC2",
                交通: "#5BA6A1",
                景观: "#92B247",
              };
              const map = {
                餐饮服务: "餐饮",
                医疗保健服务: "医疗",
                体育休闲服务: "娱乐",
                购物服务: "购物",
                科教文化服务: "文化",
                风景名胜: "景观",
                金融保险服务: "金融",
                政府机构及社会团体: "公建",
                交通设施服务: "交通",
                生活服务: "生活",
              };
              let markers = data.poiList;
              markers.forEach((marker) => {
                that.addDotCircle(
                  marker.lnglat.split("|"),
                  15,
                  colorMap[map[marker.type]] || "#000"
                );
              });
              that.addBackCircle(that.center, 1000, null, null, 0.12);

              that.setMapDataLoad();
            }, 200);
          }
        });
    },
    // peopleMap(id) {
    //   let that = this;
    // that.$axios
    //   .get(that.urlPrefix + "store/getSurroundingPeople", {
    //     params: {
    //       estate_id: id,
    //     }
    //   }).then(res => {
    //     if (res.data.success) {
    //       that.zoom = 15
    //       let data = res.data.result
    //       console.log(res)
    //       that.center = data.center.location
    //       that.addCallout(
    //         that.center,
    //         data.center.estate_name,
    //         "#4375ff",
    //         10
    //       );

    //       let markers = data.markers
    //       markers.forEach(marker => {
    //         that.addCallout(
    //           marker.location,
    //           marker.location_name,
    //           "#DBE9FF",
    //           6
    //         );
    //       })

    //       that.addBackCircle(that.center, 1000, 0);
    //     }

    //   })
    // },

    areaMap(id) {
      let that = this;
      that.$axios
        .get(that.urlPrefix + "screenshot/data/area", {
          params: {
            id: id,
          },
        })
        .then((res) => {
          if (res.data.success) {
            let data = res.data.data;
            that.center = data.area.center.split("|");
            let timer = setTimeout(() => {
              clearTimeout(timer);
              let currentMap = amapManager.getMap();
              data.cells.forEach((x) => {
                let polygon = new AMap.Polygon({
                  path: x.dots.split("-").map((y) => y.split("|")),
                  strokeColor: "#000000",
                  fillColor: x.type,
                  strokeWeight: 1,
                  strokeOpacity: 1,
                });
                currentMap.add(polygon);
              });

              let polygon = new AMap.Polygon({
                path: data.area.dots.split("-").map((x) => x.split("|")),
                strokeColor: "#000000",
                strokeWeight: 3, // 线条宽度，默认为 1
                strokeOpacity: 1,
                strokeStyle: "dashed",
                fillOpacity: 0,
                lineJoin: "round", // 折线拐点连接处样式
              });
              currentMap.add(polygon);
              currentMap.setFitView([polygon], false, [0, 0, 0, 0]);
              // that.addCallout(
              //   that.center,
              //   data.area.area_name,
              //   null,
              //   60,
              //   26,
              //   "",
              //   "#fff"
              // );
              let timer = setTimeout(() => {
                let zoom = currentMap.getZoom();
                currentMap.setZoom(zoom + 1);
                clearTimeout(timer);
              }, 100);

              that.setMapDataLoad();
            }, 200);
          }
        });
    },

    loadHxfb(id, type) {
      console.log("loadHxfb");
      let that = this;
      that.$axios
        .get(that.urlPrefix + "screenshot/data/hxfb", {
          params: {
            estate_id: id,
            type: this.sdMap[type],
          },
        })
        .then((res) => {
          if (res.data.success) {
            that.url3d = res.data.data;
            // .replace(
            //   "www.xaoji.com",
            //   "www.xaoji.com/test"
            // );
            console.log("that.url3d", that.url3d);
          }
        });
    },

    geoMap(id) {
      let that = this;
      that.$axios
        .get(that.urlPrefix + "xinghao/screenshot/onegeo", {
          params: {
            geo_id: id,
          },
        })
        .then((res) => {
          let geo = res.data.data;
          let boundary = geo.boundary.coordinates;
          let polygon = new AMap.Polygon({
            path: boundary,

            fillOpacity: 0.85,
            fillColor: "#FD8A84",

            strokeWeight: 6,
            strokeOpacity: 1,
            strokeColor: "#000000",
            strokeStyle: "dashed",
            strokeDasharray: [15, 8],
          });
          let currentMap = amapManager.getMap();
          currentMap.add(polygon);

          let markerContent = `
                  <div class="geo-label">
                    ${geo.name}
                  </div>
                  `;
          let marker = new AMap.Marker({
            position: geo.center.coordinates,
            content: markerContent,
            offset: new AMap.Pixel(0, 0),
            anchor: "bottom-center",
            zIndex: 100,
          });
          marker.setMap(currentMap);

          currentMap.setFitView();

          that.setMapDataLoad();
        });
    },

    ykPathMap(id) {
      this.$axios
        .get(this.urlPrefix + "screenshot/appoint/one", {
          params: {
            record_id: id,
          },
        })
        .then(async (res) => {
          if (res.data.success) {
            let appoint = res.data.data.appoint;
            let estates = appoint.estates;
            // let start = [appoint.start_position.lng, appoint.start_position.lat];
            // this.center = start;
            let currentMap = amapManager.getMap();
            // let startIcon = new AMap.Icon({
            //   size: new AMap.Size(48, 60),
            //   image: 'https://xiaoji-hangzhou.oss-cn-hangzhou.aliyuncs.com/img/icon_yk_plan_path_start.png',
            //   imageSize: new AMap.Size(48, 60),
            // });
            // let marker = new AMap.Marker({
            //   position: start,
            //   icon: startIcon,
            //   offset: new AMap.Pixel(-48, -60),
            // });
            // marker.setMap(currentMap);
            let paths = [];
            if (estates.length >= 1) {
              for (let i = 0; i < estates.length; i++) {
                let predot = null;
                if (estates[i - 1]) {
                  predot = estates[i - 1].sale_geo.split("-")[0].split("|");
                }
                let dot = estates[i].sale_geo.split("-")[0].split("|");
                if (predot) {
                  let steps = await this.getDrivePath(predot, dot);
                  let path = [];
                  steps.forEach((x) => {
                    x.path.forEach((y) => {
                      path.push([y.lng, y.lat]);
                    });
                  });
                  paths.push(path);
                  let polyline = new AMap.Polyline({
                    path: path,
                    strokeWeight: 5, // 线条宽度，默认为 1
                    strokeDasharray: [9, 9],
                    strokeStyle: "dashed", //线条样式
                    strokeColor: "#FF2237", // 线条颜色
                    strokeOpacity: 1,
                    lineJoin: "round", // 折线拐点连接处样式
                  });
                  currentMap.add(polyline);
                }

                let markerContent = `
                      <div class="plan-path-callout">
                        ${estates[i].real_estate_name}
                        <div class="plan-path-dot">${i + 1}</div>
                      </div>
                      `;
                let callout = new AMap.Marker({
                  position: dot,
                  content: markerContent,
                  offset: new AMap.Pixel(-60, -50),
                });
                callout.setMap(currentMap);
              }
            }

            currentMap.setFitView();

            let timer = setTimeout(() => {
              clearTimeout(timer);

              this.$axios
                .post(this.urlPrefix + "screenshot/appoint/upload", {
                  record_id: id,
                  paths: paths,
                })
                .then((res) => {
                  this.setMapDataLoad();
                });
            }, 200);
          }
        });
    },
    getDrivePath(start, end) {
      return new Promise((resolve, reject) => {
        let amap_driving = new AMap.Driving({
          policy: AMap.DrivingPolicy.LEAST_DISTANCE,
        });
        amap_driving.search(start, end, function (status, result) {
          if (status === "complete") {
            resolve(result.routes[0].steps);
          } else {
            reject("");
          }
        });
      });
    },
  },
};
</script>

<style>
#mi_map_container {
  position: relative;
  overflow: hidden;
}
#mi_load_btn {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
#mi_loaded {
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0;
}

.mi-callout {
  color: #333;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1;
  padding: 12px 20px;
  position: relative;
}
.mi-callout-sm {
  padding: 6px 10px;
  border-radius: 6px;
}
.mi-callout-sm::before {
  border-width: 2px;
  bottom: -4px;
  left: calc(50% - 2px);
}
.mi-callout::before {
  content: "";
  width: 0;
  height: 0;
  border: 4px solid transparent;
  position: absolute;
  bottom: -7px;
  left: -webkit-calc(50% - 4px);
  left: -moz-calc(50% - 4px);
  left: calc(50% - 4px);
}
.mi-callout.mi-location-v2-callout {
  border-radius: 24px;
  padding: 14px 18px;
  white-space: nowrap;
}
.mi-callout.mi-location-v2-callout::before {
  border-width: 10px;
  border-top-color: #fcde3e;
  bottom: -18px;
  left: calc(50% - 10px);
}
.mi-callout.mi-enterprise-callout {
  border-radius: 999px;
  padding: 12px 22px;
  white-space: nowrap;
  line-height: 1.2;
}
.mi-callout.mi-enterprise-callout::before {
  display: none;
}
.mi-callout.mi-distance-callout {
  border-radius: 999px;
  padding: 10px 16px;
  white-space: nowrap;
}
.mi-callout.mi-distance-callout::before {
  display: none;
}
.mi-callout.mi-area-callout {
  border-radius: 24px;
  padding: 12px 16px;
  white-space: nowrap;
}
.mi-callout.mi-area-callout::before {
  border-width: 8px;
  bottom: -14px;
  left: calc(50% - 8px);
}
.mi-callout.mi-estate-factor-callout {
  padding: 10px 16px;
  border-radius: 24px;
  white-space: nowrap;
}
.mi-callout.mi-estate-factor-callout::before {
  border-width: 8px;
  bottom: -14px;
  left: calc(50% - 8px);
}
.mi-estate-factor-distance-callout {
  position: relative;
  padding: 8px 14px;
  border-radius: 999px;
  background-color: #fff;
  color: #333333;
  font-size: 14px;
  line-height: 1;
  white-space: nowrap;
}
.mi-estate-factor-distance-callout::before {
  display: none;
}
.mi-location-v2-dot {
  width: 16px;
  height: 16px;
  background-color: #fcde3e;
  border-radius: 50%;
}
.mi-estate-icon-wrap {
  width: 38px;
  height: 52px;
}
.mi-estate-icon {
  display: block;
  width: 38px;
  height: auto;
}
.text-center {
  text-align: center;
}
.mi-color-ffffff {
  background-color: #fff;
  color: #000;
}

/* 因素地图使用产品定义的三级风险色和有利色，避免依赖旧地图色板。 */
.mi-color-ef6b57 {
  background-color: #ef6b57;
}
.mi-color-ef6b57::before {
  border-top-color: #ef6b57;
}
.mi-color-f4a43d {
  background-color: #f4a43d;
}
.mi-color-f4a43d::before {
  border-top-color: #f4a43d;
}
.mi-color-fddd25 {
  background-color: #fddd25;
}
.mi-color-fddd25::before {
  border-top-color: #fddd25;
}
.mi-color-ffa623 {
  background-color: #ffa623;
}
.mi-color-ffa623::before {
  border-top-color: #ffa623;
}
.mi-color-3DC410 {
  background-color: #3dc410;
}
.mi-color-3DC410::before {
  border-top-color: #3dc410;
}
.mi-callout.mi-planning-news-callout {
  max-width: 240px;
  padding: 10px 14px;
  line-height: 1.2;
}
.mi-color-51b86b {
  background-color: #51b86b;
}
.mi-color-51b86b::before {
  border-top-color: #51b86b;
}
.mi-color-8c9aa8 {
  background-color: #8c9aa8;
}
.mi-color-8c9aa8::before {
  border-top-color: #8c9aa8;
}

.mi-color-4375ff {
  background-color: #4375ff;
}
.mi-color-4375ff::before {
  border-top-color: #4375ff;
}
.mi-color-EFECFF {
  background-color: #efecff;
}
.mi-color-EFECFF::before {
  border-top-color: #efecff;
}
.mi-color-FFF2AF {
  background-color: #fff2af;
}
.mi-color-FFF2AF::before {
  border-top-color: #fff2af;
}
.mi-color-FFEBE5 {
  background-color: #ffebe5;
}
.mi-color-FFEBE5::before {
  border-top-color: #ffebe5;
}
.mi-color-B2F1A7 {
  background-color: #b2f1a7;
}
.mi-color-B2F1A7::before {
  border-top-color: #b2f1a7;
}

.mi-color-EEEEEE {
  background-color: #eeeeee;
}
.mi-color-EEEEEE::before {
  border-top-color: #eeeeee;
}

.mi-color-FFD2A2 {
  background-color: #ffd2a2;
}
.mi-color-FFD2A2::before {
  border-top-color: #ffd2a2;
}

.mi-color-FFF9DB {
  background-color: #fff9db;
}
.mi-color-FFF9DB::before {
  border-top-color: #fff9db;
}

.mi-color-FFDEB2 {
  background-color: #ffdeb2;
}
.mi-color-FFDEB2::before {
  border-top-color: #ffdeb2;
}

.mi-color-BBD6FF {
  background-color: #bbd6ff;
}
.mi-color-BBD6FF::before {
  border-top-color: #bbd6ff;
}

.mi-color-FDE247 {
  background-color: #fde247;
}
.mi-color-FDE247::before {
  border-top-color: #fde247;
}

.mi-color-FCDE3E {
  background-color: #fcde3e;
}
.mi-color-FCDE3E::before {
  border-top-color: #fcde3e;
}

.mi-color-FFEB1A {
  background-color: #ffeb1a;
}
.mi-color-FFEB1A::before {
  border-top-color: #ffeb1a;
}

.mi-color-6bd8e6 {
  background-color: #6bd8e6;
}
.mi-color-6bd8e6::before {
  border-top-color: #6bd8e6;
}

.mi-color-0076de {
  background-color: #0076de;
}
.mi-color-0076de::before {
  border-top-color: #0076de;
}

.mi-color-0700d9 {
  background-color: #0700d9;
}
.mi-color-0700d9::before {
  border-top-color: #0700d9;
}

.mi-color-FBE7CE {
  background-color: #fbe7ce;
}
.mi-color-FBE7CE::before {
  border-top-color: #fbe7ce;
}

.mi-color-E2D4FF {
  background-color: #e2d4ff;
}
.mi-color-E2D4FF::before {
  border-top-color: #e2d4ff;
}

.mi-color-111827 {
  background-color: #111827;
}
.mi-color-111827::before {
  border-top-color: #111827;
}

.mi-color-8FB3FF {
  background-color: #8fb3ff;
}
.mi-color-8FB3FF::before {
  border-top-color: #8fb3ff;
}

.mi-color-C7F9CC {
  background-color: #c7f9cc;
}
.mi-color-C7F9CC::before {
  border-top-color: #c7f9cc;
}

.mi-color-00FFC2 {
  background-color: #00ffc2;
}
.mi-color-00FFC2::before {
  border-top-color: #00ffc2;
}

.mi-color-92B247 {
  background-color: #92b247;
}
.mi-color-92B247::before {
  border-top-color: #92b247;
}

.mi-color-F59E0B {
  background-color: #f59e0b;
}
.mi-color-F59E0B::before {
  border-top-color: #f59e0b;
}

.mi-color-14B8A6 {
  background-color: #14b8a6;
}
.mi-color-14B8A6::before {
  border-top-color: #14b8a6;
}

.mi-color-E2E9FF {
  background-color: #e2e9ff;
}
.mi-color-E2E9FF::before {
  border-top-color: #e2e9ff;
}
.mi-color-3F7CE8 {
  background-color: #3f7ce8;
}
.mi-color-3F7CE8::before {
  border-top-color: #3f7ce8;
}

.mi-color-FF0000 {
  background-color: #ff0000;
}
.mi-color-FF0000::before {
  border-top-color: #ff0000;
}
.mi-color-FFAB89 {
  background-color: #ffab89;
}
.mi-color-FFAB89::before {
  border-top-color: #ffab89;
}
.mi-color-FF869A {
  background-color: #ff869a;
}
.mi-color-FF869A::before {
  border-top-color: #ff869a;
}
.mi-color-9900FF {
  background-color: #9900ff;
}
.mi-color-9900FF::before {
  border-top-color: #9900ff;
}
.mi-color-6A9DFF {
  background-color: #6a9dff;
}
.mi-color-6A9DFF::before {
  border-top-color: #6a9dff;
}
.mi-color-FFCC00 {
  background-color: #ffcc00;
}
.mi-color-FFCC00::before {
  border-top-color: #ffcc00;
}
.mi-color-FFA52D {
  background-color: #ffa52d;
}
.mi-color-FFA52D::before {
  border-top-color: #ffa52d;
}
.mi-color-10CAE7 {
  background-color: #10cae7;
}
.mi-color-10CAE7::before {
  border-top-color: #10cae7;
}
.mi-color-5CC65B {
  background-color: #5cc65b;
}
.mi-color-5CC65B::before {
  border-top-color: #5cc65b;
}
.mi-color-AB82FF {
  background-color: #ab82ff;
}
.mi-color-AB82FF::before {
  border-top-color: #ab82ff;
}
.mi-color-FF612C {
  background-color: #ff612c;
}
.mi-color-FF612C::before {
  border-top-color: #ff612c;
}
.mi-color-00DDFF {
  background-color: #00ddff;
}
.mi-color-00DDFF::before {
  border-top-color: #00ddff;
}
.mi-color-CE7704 {
  background-color: #ce7704;
}
.mi-color-CE7704::before {
  border-top-color: #ce7704;
}
.mi-color-DC72FF {
  background-color: #dc72ff;
}
.mi-color-DC72FF::before {
  border-top-color: #dc72ff;
}

.model3d {
  position: relative;
}
.geo-label {
  font-size: 20px;
  color: #000;
  background-color: #fff;
  border-radius: 15px;
  line-height: 1;
  padding: 5px 8px;
}

.plan-path-dot {
  position: absolute;
  left: calc(50% - 17px);
  top: 60px;
  background-color: #ffec41;
  font-size: 16px;
  text-align: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  line-height: 30px;
  border: 2px solid #000000;
}
.plan-path-callout {
  background-color: #ffec41;
  color: #3d3d3d;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1;
  padding: 12px 20px;
  position: relative;
  border: 2px solid #000000;
  box-sizing: border-box;
}
.plan-path-callout::before {
  content: "";
  width: 0;
  height: 0;
  position: absolute;
  bottom: -17px;
  left: calc(50% - 10px);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #ffec41;
  z-index: 2;
}
.plan-path-callout::after {
  content: "";
  width: 0;
  height: 0;
  position: absolute;
  bottom: -19px;
  left: calc(50% - 14px);
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-top: 14px solid #000000;
}
</style>



// WEBPACK FOOTER //
// src/page/MapImage.vue